exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tmr-export-container[data-v-056f32b5] {\n  padding: 25px;\n  max-width: 600px;\n  margin: auto;\n}\n", ""]);

// exports
